// extracted by mini-css-extract-plugin
export default {"LdsRing":"Spinner_LdsRing__65CtO","lds-ring":"Spinner_lds-ring__E4Ujw","SpinnerOverlay":"Spinner_SpinnerOverlay__POc5k"};